import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import AppareilList from './appareils/AppareilList';
import Clients from './clients/Clients';
import ClientDetails from './clients/ClientDetails';
import Kits from './kits/Kits';
import Devices from './devices/Devices';
import KitDetails from './kits/KitDetails';
import Users from './Users';
import Accueil from './Accueil';
import Operations from './Operations';
import Administration from './Administration';
import Tutoriels from './Tutoriels';
import Resoudre from './Resoudre';
import Monitorer from './Monitorer';
import Preparer from './Preparer';
import Marketing from './Marketing';
import IncidentsCamera from './incidentsCamera/IncidentsCamera';
import CockpitInvestigation from './cockpit/CockpitInvestigation';
import CockpitOperationnel from './cockpit/CockpitOperationnel';
import CockpitSanteRecente from './cockpit/CockpitSanteRecente';
import CockpitAmeliorationSysteme from './cockpit/CockpitAmeliorationSysteme';
import { DeviceFormUpdate } from './devices/DeviceForm';
import DeploiementsPage from './deploiements/DeploiementsPage';
import DeploiementReportDetails from './deploiements/DeploiementReportDetails';
import Ingenierie from './Ingenierie';
import DeploiementsSitewebPage from './deploiementsSiteweb/DeploiementsSitewebPage';
import SitewebReportDetails from './deploiementsSiteweb/SitewebReportDetails';

const SwitchRoutes = ({ isMobile }) => (
  <Switch>
    <Route exact path="/" render={(props) => <Accueil {...props} isMobile={isMobile} />} />
    <Route exact path="/accueil" render={(props) => <Accueil {...props} isMobile={isMobile} />} />
    <Route exact path="/users" render={(props) => <Users {...props} isMobile={isMobile} />} />
    <Route exact path="/clients" render={(props) => <Clients {...props} isMobile={isMobile} />} />
    <Route exact path="/devices" render={(props) => <Devices {...props} isMobile={isMobile} />} />
    <Route path="/kit/" render={(props) => <KitDetails {...props} isMobile={isMobile} />} />
    <Route exact path="/kits" render={(props) => <Kits {...props} isMobile={isMobile} />} />
    <Route path="/client/" render={(props) => <ClientDetails {...props} isMobile={isMobile} />} />
    <Route exact path="/Administration" render={(props) => <Administration {...props} isMobile={isMobile} />} />
    <Route exact path="/Marketing" render={(props) => <Marketing {...props} isMobile={isMobile} />} />
    <Route exact path="/Ingenierie" render={(props) => <Ingenierie {...props} isMobile={isMobile} />} />
    <Route exact path="/Operations" render={(props) => <Operations {...props} isMobile={isMobile} />} />
    <Route exact path="/Operations/Tutoriels" render={(props) => <Tutoriels {...props} isMobile={isMobile} />} />
    <Route exact path="/Operations/Resoudre" render={(props) => <Resoudre {...props} isMobile={isMobile} />} />
    <Route exact path="/Operations/Monitorer" render={(props) => <Monitorer {...props} isMobile={isMobile} />} />
    <Route exact path="/Operations/IncidentsCamera" render={(props) => <IncidentsCamera {...props} isMobile={isMobile} />} />
    <Route exact path="/cockpit" render={(props) => <CockpitOperationnel {...props} isMobile={isMobile} />} />
    <Route exact path="/cockpit/sante-recente" render={(props) => <CockpitSanteRecente {...props} isMobile={isMobile} />} />
    <Route exact path="/cockpit/amelioration" render={(props) => <CockpitAmeliorationSysteme {...props} isMobile={isMobile} />} />
    <Route exact path="/cockpit/investigation" render={(props) => <CockpitInvestigation {...props} isMobile={isMobile} />} />
    <Route exact path="/Operations/Preparer" render={(props) => <Preparer {...props} isMobile={isMobile} />} />
    <Route exact path="/Ingenierie/Deploiements" render={(props) => <DeploiementsPage {...props} isMobile={isMobile} />} />
    <Route exact path="/Ingenierie/Deploiements/:id" render={(props) => <DeploiementReportDetails {...props} isMobile={isMobile} />} />
    <Route exact path="/Ingenierie/DeploiementsSiteweb" render={(props) => <DeploiementsSitewebPage {...props} isMobile={isMobile} />} />
    <Route exact path="/Ingenierie/DeploiementsSiteweb/:id" render={(props) => <SitewebReportDetails {...props} isMobile={isMobile} />} />
    <Route path="/appareils/" render={(props) => <AppareilList {...props} isMobile={isMobile} />} />
    <Route path="/device/" render={(props) => <DeviceFormUpdate {...props} isMobile={isMobile} />} />
  </Switch>
);

export default withRouter(SwitchRoutes);



// WEBPACK FOOTER //
// src/components/SwitchRoutes.jsx